import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getAwardGroupsSummaries, getAwardSummaries, getRegionAwardSummaries } from './index';

export const createAwardSummariesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getAwardSummaries: (instance: IPublicClientApplication, programId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAwardSummaries(fetchContext, programId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAwardSummaries', isInFlight);
    },
  ),
  getAwardGroupsSummaries: (instance: IPublicClientApplication, programId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getAwardGroupsSummaries(fetchContext, programId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getAwardGroupsSummaries', isInFlight);
    },
  ),
  getRegionAwardSummaries: (instance: IPublicClientApplication, programId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getRegionAwardSummaries(fetchContext, programId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getRegionAwardSummaries', isInFlight);
    },
  ),
});
